import { useLayoutEffect, useRef, useState } from 'react';
import { getPanelOffsetTop } from './getPanelOffsetTop';

interface UseFilterPanelOffsetReturn {
  menuRef: React.RefObject<HTMLDivElement>;
  panelRef: React.RefObject<HTMLDivElement>;
  offsetTop: number;
}

export const useFilterPanelOffset = (isOpen: boolean, activeFilterKey: string | null): UseFilterPanelOffsetReturn => {
  const menuRef = useRef<HTMLDivElement>(null);
  const panelRef = useRef<HTMLDivElement>(null);
  const [offsetTop, setOffsetTop] = useState(0);

  useLayoutEffect(() => {
    if (!isOpen || !activeFilterKey) {
      setOffsetTop(0);

      return undefined;
    }

    const updatePosition = (): void => {
      const menu = menuRef.current;
      const button = menu?.querySelector<HTMLButtonElement>(`[data-filter-key="${activeFilterKey}"]`);

      if (!menu || !button) return;

      const { top: menuTop } = menu.getBoundingClientRect();
      const { top: buttonTop } = button.getBoundingClientRect();
      const panelHeight = panelRef.current?.getBoundingClientRect().height ?? 0;

      setOffsetTop(
        getPanelOffsetTop({
          buttonTop,
          menuTop,
          panelHeight,
          viewportHeight: window.innerHeight,
        }),
      );
    };

    updatePosition();

    const filterList = menuRef.current?.querySelector('[data-filter-list]');

    filterList?.addEventListener('scroll', updatePosition);
    window.addEventListener('resize', updatePosition);

    return () => {
      filterList?.removeEventListener('scroll', updatePosition);
      window.removeEventListener('resize', updatePosition);
    };
  }, [activeFilterKey, isOpen]);

  return { menuRef, panelRef, offsetTop };
};
